import App from 'app/app.js';

function LtCheckOutWithPayPalButtonDirective() {
  return {
    restrict: 'E',
    template:
      '<div class="col-xs-12 paypal-wrapper payment-button" data-test-paypal-btn>' +
      '    <img class="paypal active" lt-auto-src="assets/images/payment/checkout-logo-new.png" />' +
      '</div>',
    controller: 'LtCheckOutWithPayPalButtonCtrl',
    controllerAs: 'checkOutWithPayPalButtonCtrl'
  };
}

App.directive('ltCheckOutWithPayPalButton', LtCheckOutWithPayPalButtonDirective);
